import Module from 'lib/module';
import jquery from 'jquery';

@Module.define('products')
class Products extends Module {
    main() {
        this.formSubmit();
    }

    bindEvents() {
    }

    formSubmit() {

        $('#product-form').on('submit', function (e) {
            e.preventDefault();
            let productSKU = $('#product-form').find(':selected').attr('value');
            let formActionUrl = $('#product-form').attr('action');
            let redirectUrl = `${formActionUrl}?product=${productSKU}`
            //$('#product-form').attr('action', `${formActionUrl}?sku=${productSKU}`);
            window.location = redirectUrl;
        });
    }
}